var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('desk-global',{attrs:{"id":"app"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('desk-header')]},proxy:true}])},[_c('desk-main')],1)}
var staticRenderFns = []

export { render, staticRenderFns }